export default "https://cdn-static.gokick.com/assets/96917af4b324ebd1ae50a0309f8a33967fe87b4d/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";